import React, { Component } from 'react';
import { history } from './../configureStore';
import './BackButton.css';
import { FeatherButton } from './FeatherButton';
import { ArrowLeft, X } from 'react-feather';

export default class BackButton extends Component {
    render() {
        return (
            <FeatherButton feather={<ArrowLeft color="#888" size="30px" />} classNames={["back-button"]} onClick={history.goBack} ></FeatherButton>
        )
    }
}

export class BackButtonX extends Component {
    render() {
        return (
            <FeatherButton feather={<X color="#888" size="30px" />} classNames={["back-button"]} onClick={history.goBack} ></FeatherButton>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/BackButton.js